export function getCurrentTimestamp(): string {
  return new Date().toISOString();
}
